export const useStatus = [
    {value: 0, label: '正常' },
    {value: 1, label: '停用' },
    {value: 2, label: '封存' }
]
export const options = [
    {value: 0, label: '否' },
    {value: 1, label: '是' },
]

export const meterType = [
    {value: '水表', label: '水表' },
    {value: '电表', label: '电表' },
    {value: '空调电表', label: '空调电表' },
    {value: '新风电表', label: '新风电表' },
    {value: '公摊电表', label: '公摊电表' },
]

export const simpleMeterType = [
    {value: '水表', label: '水表' },
    {value: '电表', label: '电表' }
]

export const openCloseStatus = [
    {value: 1, label: '通' },
    {value: 30, label: '送电中' },
    {value: 2, label: '断' },
    {value: 31, label: '断电中' }
]

export const orderStatus = [
    {value: 1, label: '已生成' },
    {value: 0, label: '未生成' }
]

export const payStatus = [
    {value: 1, label: '已销' },
    {value: 0, label: '未销' }
]

export const deductionStatus = [
    {value: 1, label: '已生成账单' },
    {value: 2, label: '财务审核' },
    {value: 3, label: '调整完成' }
]

/**
 * 读表超时
 */
export const readTimeout = [
    {value: 0, label: '未读数' },
    {value: 1, label: '读表超时1天' },
    {value: 2, label: '读表超时2天' },
    {value: 3, label: '读表超时3天' },
    {value: 7, label: '读表超时7天' },
    {value: 15, label: '读表超时15天' },
    {value: 30, label: '读表超时30天' }
]

/**
 * 通断状态
 */
export const openClose = [
    {value: 1, label: '通' },
    {value: 30, label: '送电中' },
    {value: 2, label: '断' },
    {value: 31, label: '断电中' }
]

/**
 * 物业费绑定状态
 */
 export const bindFeeStatus = [
    {value: 1, label: '已绑' },
    {value: 0, label: '未绑' }
]
/**
 * 预警额度
 */
 export const warnThreshod = [
    {value: 100, label: '低于100(度、吨)' },
    {value: 50, label: '低于50(度、吨)' },
    {value: 30, label: '低于30(度、吨)' },
    {value: 10, label: '低于10(度、吨)' },
    {value: 0, label: '低于0(度、吨)' },
    {value: -100, label: '低于-100(度、吨)' }
]

/**
 * 收费方式
 */
export const payMode = [
    {value: 1, label: '现金' },
    {value: 2, label: '转账' },
    {value: 3, label: 'pos机' },
    {value: 4, label: '微信' },
    {value: 5, label: '支付宝' },
    {value: 6, label: '银行划扣' },
    {value: 7, label: '其他' },
    {value: 8, label: '转冲' },
]

/**
 * 退款状态
 */
export const refundStatus = [
    {value: 0, label: '正常' },
    {value: 1, label: '已退款' },
]

/**
 * 精度
 */
export const scale = [
    {value: 0, label: '元' },
    {value: 1, label: '角' },
    {value: 2, label: '分' },
]

/**
 * 收费入口
 */
 export const mergeFlag = [
    {value: 0, label: '仪表收费' },
    {value: 1, label: '日常收费' },
]

/**
 * 销帐状态
 */
 export const writeOffStatusFlag = [
    {value: 1, label: '已销账' },
    {value: 0, label: '未销帐' },
]

/**
 * 通断模式
 */
export const onOff = [
    {value: 0, label: '自动' },
    {value: 1, label: '手动' },
    {value: 2, label: '不做通断' },
]

export default {
    useStatus,
    options,
    meterType,
    simpleMeterType,
    openCloseStatus,
    orderStatus,
    payStatus,
    deductionStatus,
    readTimeout,
    openClose,
    bindFeeStatus,
    warnThreshod,
    payMode,
    refundStatus,
    mergeFlag,
    scale,
    onOff
}